/** Customer-facing horizon scanning copy. €29 per source / month; contact page until Stripe price is configured. */
export const horizonScanningCopy = {
  productName: "Horizon scanning",
  claim: "Lose the fear of missing updates. A recurring digest from the sources you select, filtered to your topics.",
  completeness: "Complete coverage of the sources you select.",
  credibility: "REGTECH 100",
  fromPrice: "€29 per source per month",
  priceDetail:
    "Free week of weekly digests. Continue after the trial (€29 per source per month) to unlock daily, weekly or bi-weekly. Recipients free up to 10.",
  contactUsLabel: "Contact us",
} as const;
